export class SearchHttp {
    /**
     * Do super search
     * @param q
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async doSearch(q) {
        try {
            return await window.axios.get(`search?q=${q}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
